// extracted by mini-css-extract-plugin
module.exports = {"listItem":"TheHomeNews_listItem_1gPmu","more":"TheHomeNews_more_IAksW","timetag":"TheHomeNews_timetag_2KF8q","spinAround":"TheHomeNews_spinAround_2vCfb"};